import { Paper, Box, alpha, styled } from '@mui/material'

export const MessagesContainer = styled(Box)(({ theme }) => ({
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  py: theme.spacing(2),
  width: '100%',
  maxWidth: 980,
  margin: '0 auto',
  minHeight: 0,
  '&::-webkit-scrollbar': { display: 'none' },
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
}))

export const MessageRow = styled(Box, {
  shouldForwardProp: prop => prop !== 'isUser',
})(({ isUser }) => ({
  display: 'flex',
  justifyContent: isUser ? 'flex-end' : 'flex-start',
  marginBottom: 20,
  paddingLeft: 16,
  paddingRight: 16,
  position: 'relative',
  '&:hover .message-actions': {
    opacity: 1,
  },
}))

export const MessageBubble = styled(Paper, {
  shouldForwardProp: prop => prop !== 'isUser' && prop !== 'variant',
})(({ theme, isUser, variant }) => {
  let background = isUser ? theme.palette.primary[300] : 'transparent'

  if (variant === 'audio_transcription') {
    background = isUser ? 'var(--brand-500)' : alpha(theme.palette.grey[100], 0.5)
  } else if (variant === 'audio_response') {
    background = isUser
      ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      : '#f8fafc'
  }

  return {
    maxWidth: '75%',
    minWidth: 'auto',
    borderRadius: isUser ? 30 : 12,
    padding: isUser ? '10px 16px' : '10px 12px',
    color: isUser ? 'white' : 'black',
    overflow: 'visible',
    position: 'relative',
    maxHeight: 'auto',
    transition: 'box-shadow 0.2s ease-in-out, transform 0.2s ease-in-out',
    background,
    border: 'none',
    boxShadow: 'none',
  }
})

export const IconWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
})
